import { render, staticRenderFns } from "./CustomerOrthoElastic.vue?vue&type=template&id=ddc72c8c"
import script from "./CustomerOrthoElastic.vue?vue&type=script&lang=js"
export * from "./CustomerOrthoElastic.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrthoElastic.vue?vue&type=style&index=0&id=ddc72c8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports